import React, { useEffect, useRef, useState } from "react";
import { apiResponse } from "../../../../utils/apiResponse";
import { API_URL } from "../../../../utils/apiRoutes";
import { Button, Table } from "react-bootstrap";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import Loader from "../../../Loader/Loader";
import { apiCall } from "../../../../utils/axiosService";
import { compName, month } from "../../../../utils/constant";
import { commonService } from "../../../../utils/commonService";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import WidgetNote from "../../WidgetNote";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import AddWidgetModal from "../../AddWidgetModal";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import moment from "moment";

const AnnualCancellationSummary = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const DummyCancellationData = [{ "asofdate": "2025-10-30", "monthname": "April", "cy_cancellednights": 219, "cy_adr": "93", "cy_totalloss": "20443", "cy_cancelledratio": "8.20", "cy_totalinventory": 2670, "cy_avgleadtime": "3.80", "ly_cancellednights": 277, "ly_adr": "109", "ly_totalloss": "30279", "ly_cancelledratio": "10.37", "ly_totalinventory": "2670.00", "ly_avgleadtime": "10.30", "stly_cancellednights": 277, "stly_adr": "109", "stly_totalloss": "30279", "stly_cancelledratio": "10.37", "stly_totalinventory": "2670.00", "stly_avgleadtime": "10.30" }, { "asofdate": "2025-10-30", "monthname": "August", "cy_cancellednights": 266, "cy_adr": "106", "cy_totalloss": "28132", "cy_cancelledratio": "9.64", "cy_totalinventory": 2759, "cy_avgleadtime": "3.07", "ly_cancellednights": 75, "ly_adr": "102", "ly_totalloss": "7621", "ly_cancelledratio": "2.72", "ly_totalinventory": "2759.00", "ly_avgleadtime": "9.96", "stly_cancellednights": 75, "stly_adr": "102", "stly_totalloss": "7621", "stly_cancelledratio": "2.72", "stly_totalinventory": "2759.00", "stly_avgleadtime": "9.96" }, { "asofdate": "2025-10-30", "monthname": "December", "cy_cancellednights": 0, "cy_adr": "0", "cy_totalloss": "0", "cy_cancelledratio": "0.00", "cy_totalinventory": 2759, "cy_avgleadtime": null, "ly_cancellednights": 38, "ly_adr": "80", "ly_totalloss": "3050", "ly_cancelledratio": "1.38", "ly_totalinventory": "2759.00", "ly_avgleadtime": "6.31", "stly_cancellednights": 2, "stly_adr": "83", "stly_totalloss": "166", "stly_cancelledratio": "0.07", "stly_totalinventory": "2759.00", "stly_avgleadtime": "21.00" }, { "asofdate": "2025-10-30", "monthname": "February", "cy_cancellednights": 85, "cy_adr": "90", "cy_totalloss": "7641", "cy_cancelledratio": "3.41", "cy_totalinventory": 2492, "cy_avgleadtime": "2.41", "ly_cancellednights": 78, "ly_adr": "80", "ly_totalloss": "6254", "ly_cancelledratio": "3.13", "ly_totalinventory": "2492.00", "ly_avgleadtime": "3.69", "stly_cancellednights": 78, "stly_adr": "80", "stly_totalloss": "6254", "stly_cancelledratio": "3.13", "stly_totalinventory": "2492.00", "stly_avgleadtime": "3.69" }, { "asofdate": "2025-10-30", "monthname": "January", "cy_cancellednights": 131, "cy_adr": "89", "cy_totalloss": "11714", "cy_cancelledratio": "4.75", "cy_totalinventory": 2759, "cy_avgleadtime": "10.32", "ly_cancellednights": 95, "ly_adr": "72", "ly_totalloss": "6832", "ly_cancelledratio": "3.44", "ly_totalinventory": "2759.00", "ly_avgleadtime": "7.84", "stly_cancellednights": 95, "stly_adr": "72", "stly_totalloss": "6832", "stly_cancelledratio": "3.44", "stly_totalinventory": "2759.00", "stly_avgleadtime": "7.84" }, { "asofdate": "2025-10-30", "monthname": "July", "cy_cancellednights": 248, "cy_adr": "111", "cy_totalloss": "27540", "cy_cancelledratio": "8.99", "cy_totalinventory": 2759, "cy_avgleadtime": "8.62", "ly_cancellednights": 107, "ly_adr": "89", "ly_totalloss": "9567", "ly_cancelledratio": "3.88", "ly_totalinventory": "2759.00", "ly_avgleadtime": "4.92", "stly_cancellednights": 107, "stly_adr": "89", "stly_totalloss": "9567", "stly_cancelledratio": "3.88", "stly_totalinventory": "2759.00", "stly_avgleadtime": "4.92" }, { "asofdate": "2025-10-30", "monthname": "June", "cy_cancellednights": 240, "cy_adr": "119", "cy_totalloss": "28509", "cy_cancelledratio": "8.99", "cy_totalinventory": 2670, "cy_avgleadtime": "7.44", "ly_cancellednights": 154, "ly_adr": "87", "ly_totalloss": "13386", "ly_cancelledratio": "5.77", "ly_totalinventory": "2670.00", "ly_avgleadtime": "13.31", "stly_cancellednights": 154, "stly_adr": "87", "stly_totalloss": "13386", "stly_cancelledratio": "5.77", "stly_totalinventory": "2670.00", "stly_avgleadtime": "13.31" }, { "asofdate": "2025-10-30", "monthname": "March", "cy_cancellednights": 224, "cy_adr": "118", "cy_totalloss": "26369", "cy_cancelledratio": "8.12", "cy_totalinventory": 2759, "cy_avgleadtime": "4.26", "ly_cancellednights": 253, "ly_adr": "80", "ly_totalloss": "20155", "ly_cancelledratio": "9.17", "ly_totalinventory": "2759.00", "ly_avgleadtime": "4.34", "stly_cancellednights": 253, "stly_adr": "80", "stly_totalloss": "20155", "stly_cancelledratio": "9.17", "stly_totalinventory": "2759.00", "stly_avgleadtime": "4.34" }, { "asofdate": "2025-10-30", "monthname": "May", "cy_cancellednights": 258, "cy_adr": "110", "cy_totalloss": "28426", "cy_cancelledratio": "9.35", "cy_totalinventory": 2759, "cy_avgleadtime": "5.56", "ly_cancellednights": 212, "ly_adr": "88", "ly_totalloss": "18618", "ly_cancelledratio": "7.68", "ly_totalinventory": "2759.00", "ly_avgleadtime": "8.53", "stly_cancellednights": 212, "stly_adr": "88", "stly_totalloss": "18618", "stly_cancelledratio": "7.68", "stly_totalinventory": "2759.00", "stly_avgleadtime": "8.53" }, { "asofdate": "2025-10-30", "monthname": "November", "cy_cancellednights": 15, "cy_adr": "90", "cy_totalloss": "1344", "cy_cancelledratio": "0.56", "cy_totalinventory": 2670, "cy_avgleadtime": "31.25", "ly_cancellednights": 19, "ly_adr": "89", "ly_totalloss": "1682", "ly_cancelledratio": "0.71", "ly_totalinventory": "2670.00", "ly_avgleadtime": "9.07", "stly_cancellednights": 7, "stly_adr": "96", "stly_totalloss": "672", "stly_cancelledratio": "0.26", "stly_totalinventory": "2670.00", "stly_avgleadtime": "20.40" }, { "asofdate": "2025-10-30", "monthname": "October", "cy_cancellednights": 409, "cy_adr": "71", "cy_totalloss": "29068", "cy_cancelledratio": "14.82", "cy_totalinventory": 2759, "cy_avgleadtime": "12.95", "ly_cancellednights": 135, "ly_adr": "78", "ly_totalloss": "10535", "ly_cancelledratio": "4.89", "ly_totalinventory": "2759.00", "ly_avgleadtime": "5.65", "stly_cancellednights": 135, "stly_adr": "78", "stly_totalloss": "10535", "stly_cancelledratio": "4.89", "stly_totalinventory": "2759.00", "stly_avgleadtime": "5.65" }, { "asofdate": "2025-10-30", "monthname": "September", "cy_cancellednights": 197, "cy_adr": "72", "cy_totalloss": "14142", "cy_cancelledratio": "7.38", "cy_totalinventory": 2670, "cy_avgleadtime": "19.54", "ly_cancellednights": 52, "ly_adr": "90", "ly_totalloss": "4659", "ly_cancelledratio": "1.95", "ly_totalinventory": "2670.00", "ly_avgleadtime": "15.76", "stly_cancellednights": 52, "stly_adr": "90", "stly_totalloss": "4659", "stly_cancelledratio": "1.95", "stly_totalinventory": "2670.00", "stly_avgleadtime": "15.76" }];



    const [widgetModal, setWidgetModal] = useState(false);
    const widgetDetailRef = useRef();
    const [showNoteSidebar, setShowNoteSidebar] = useState(false);
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );
    const { snapshottitle, propertyCode, snapshotId } = useParams();
    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };



    const [CancellationData, setCancellationData] = useState([]);
    const [Loading, setLoading] = useState(false);
    const getCancellationData = async () => {
        setLoading(true);
        let cancellationResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.CANCELLATION.GET_CANCELLATION_BOOKING_REV_LOSS,
                body: { propertyCode: para?.propertyCode, AsOfDate: para?.asOfDate },
            },
            false
        );

        let response = apiResponse(false, cancellationResponse);

        if (response?.isValidate) {
            setCancellationData(response?.data?.data);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setCancellationData([]);
            setLoading(false);
        }
    };



    //GET_CANCELLATION_BOOKING_REV_LOSS
    useEffect(() => {
        if (api === 0) {
            setCancellationData(DummyCancellationData);
            //setCyData(cyTableData);
            //setLyData(lyTableData);
            //setStlyData(stlyTableData);
        } else {
            if (para?.asOfDate) {
                getCancellationData()
                //getCyCancellationData();
                //getLyCancellationData();
                //getStlyCancellationData();
            }
        }
    }, [para?.asOfDate]);

    const [tblids, settblids] = useState({
        annsummaryCancellationCommon: commonService.GenerateGUID(),
    });

    return (
        <div className="widget-container" style={{ position: "relative" }}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    {/* <Button className="heading-menu-btns" type="button">
            <img
              src={NoteIcon}
              alt="menuIcon"
              onClick={() => {
                setShowNoteSidebar(true);
              }}
            />
          </Button> */}
                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("AnnualCancellationSummary", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.annsummaryCancellationCommon,
                                    "Annual Summary Cancellation",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("AnnualCancellationSummary", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.annSummaryCancellation,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("AnnualCancellationSummary", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.annsummaryCancellationCommon}
                            onClick={() =>
                                commonService.fnExportInCSV(
                                    tblids.annsummaryCancellationCommon,
                                    // "Annual Summary Cancellation"
                                    `${para?.propertyCode}-Annual Summary Cancellation-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                )
                            }
                        />
                    </Button>
                </div>
            )}
            <div className="ViewPropertySetupTable">
                <div className="stripped__table">
                    <table id={tblids.annsummaryCancellationCommon} responsive>
                        <thead>
                            <tr>
                                <th className="border_right"></th>
                                <th colSpan={5} className="text-center border_right">
                                    Cancelled Booking Revenue Loss CY
                                </th>
                                <th colSpan={5} className="text-center border_right">
                                    Cancelled Booking Revenue Loss STLY
                                </th>
                                <th colSpan={5} className="text-center">
                                    Cancelled Booking Revenue Loss LY
                                </th>
                            </tr>
                            <tr>
                                <th className="text-center border_right">Month</th>
                                <th className="text-center">Total Inventory</th>
                                <th className="text-center">Cancelled Nights</th>
                                <th className="text-center">ADR</th>
                                <th className="text-center">Cancelled Occupancy</th>
                                <th className="text-center border_right">Total Loss</th>
                                <th className="text-center">Total Inventory</th>
                                <th className="text-center">Cancelled Bookings</th>
                                <th className="text-center">ADR</th>
                                <th className="text-center">Cancelled Occupancy</th>
                                <th className="text-center border_right">Total Loss</th>
                                <th className="text-center">Total Inventory</th>
                                <th className="text-center">Cancelled Bookings</th>
                                <th className="text-center">ADR</th>
                                <th className="text-center">Cancelled Occupancy</th>
                                <th className="text-center">Total Loss</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                Loading ?
                                    <tr style={{ height: "80px", position: "relative" }}> <Loader /> </tr>
                                    :
                                    <>
                                        {
                                            CancellationData.map((item, index) =>
                                                <tr>
                                                    <td className="text-center border_right">{item.monthname}</td>

                                                    <td className="text-center">{item.cy_totalinventory}</td>
                                                    <td className="text-center">{item.cy_cancellednights}</td>
                                                    <td className="text-center">{commonService.formateAmount(item.cy_adr)}</td>
                                                    <td className="text-center">{item.cy_cancelledratio}</td>
                                                    <td className="text-center border_right">{commonService.formateAmount(item.cy_totalloss)}</td>

                                                    <td className="text-center">{item.stly_totalinventory}</td>
                                                    <td className="text-center">{item.stly_cancellednights}</td>
                                                    <td className="text-center">{commonService.formateAmount(item.stly_adr)}</td>
                                                    <td className="text-center">{item.stly_cancelledratio}</td>
                                                    <td className="text-center border_right">{commonService.formateAmount(item.stly_totalloss)}</td>

                                                    <td className="text-center">{item.ly_totalinventory}</td>
                                                    <td className="text-center">{item.ly_cancellednights}</td>
                                                    <td className="text-center">{commonService.formateAmount(item.ly_adr)}</td>
                                                    <td className="text-center">{item.ly_cancelledratio}</td>
                                                    <td className="text-center border_right">{commonService.formateAmount(item.ly_totalloss)}</td>
                                                </tr>
                                            )
                                        }

                                    </>
                            }
                            {/*{cyLoading === true ||*/}
                            {/*    lyLoading === true ||*/}
                            {/*    stlyLoading === true ? (*/}
                            {/*    <tr style={{ height: "80px", position: "relative" }}>*/}
                            {/*        <Loader />*/}
                            {/*    </tr>*/}
                            {/*) : (*/}
                            {/*    month?.map((item, index) => {*/}
                            {/*        let cyMonthData = cyData?.filter(*/}
                            {/*            (x) => x?.MonthName?.trim() === item*/}
                            {/*        );*/}

                            {/*        let lyMonthData = lyData?.filter(*/}
                            {/*            (x) => x?.MonthName?.trim() === item*/}
                            {/*        );*/}

                            {/*        let stlyMonthData = stlyData?.filter(*/}
                            {/*            (x) => x?.MonthName?.trim() === item*/}
                            {/*        );*/}

                            {/*        inventory =*/}
                            {/*            inventory +*/}
                            {/*            (cyMonthData?.[0]?.["Total Inventory"]*/}
                            {/*                ? parseInt(cyMonthData?.[0]?.["Total Inventory"])*/}
                            {/*                : 0);*/}

                            {/*        cancelledNights =*/}
                            {/*            cancelledNights +*/}
                            {/*            (cyMonthData?.[0]?.["CancelledNights"]*/}
                            {/*                ? parseInt(cyMonthData?.[0]?.["CancelledNights"])*/}
                            {/*                : 0);*/}

                            {/*        adr =*/}
                            {/*            adr +*/}
                            {/*            (cyMonthData?.[0]?.["ADR"]*/}
                            {/*                ? parseInt(cyMonthData?.[0]?.["ADR"])*/}
                            {/*                : 0);*/}

                            {/*        cancelledRatio =*/}
                            {/*            cancelledRatio +*/}
                            {/*            (cyMonthData?.[0]?.["CancelledRatio"]*/}
                            {/*                ? parseFloat(cyMonthData?.[0]?.["CancelledRatio"])*/}
                            {/*                : 0);*/}

                            {/*        totalLoss =*/}
                            {/*            totalLoss +*/}
                            {/*            (cyMonthData?.[0]?.["TotalLoss"]*/}
                            {/*                ? parseInt(cyMonthData?.[0]?.["TotalLoss"])*/}
                            {/*                : 0);*/}

                            {/*        if (*/}
                            {/*            cyMonthData?.[0]?.["CancelledRatio"] !== "0.00" &&*/}
                            {/*            cyMonthData?.[0]?.["CancelledRatio"]*/}
                            {/*        ) {*/}
                            {/*            cancelledRatioCount = cancelledRatioCount + 1;*/}
                            {/*        }*/}

                            {/*        if (*/}
                            {/*            cyMonthData?.[0]?.["ADR"] !== "0" &&*/}
                            {/*            cyMonthData?.[0]?.["ADR"]*/}
                            {/*        ) {*/}
                            {/*            adrCount = adrCount + 1;*/}
                            {/*        }*/}

                            {/*        lyinventory =*/}
                            {/*            lyinventory +*/}
                            {/*            (lyMonthData?.[0]?.["TotalInventory"]*/}
                            {/*                ? parseInt(lyMonthData?.[0]?.["TotalInventory"])*/}
                            {/*                : 0);*/}

                            {/*        lycancelledNights =*/}
                            {/*            lycancelledNights +*/}
                            {/*            (lyMonthData?.[0]?.["CancelledNights"]*/}
                            {/*                ? parseInt(lyMonthData?.[0]?.["CancelledNights"])*/}
                            {/*                : 0);*/}

                            {/*        lyadr =*/}
                            {/*            lyadr +*/}
                            {/*            (lyMonthData?.[0]?.["ADR"]*/}
                            {/*                ? parseInt(lyMonthData?.[0]?.["ADR"])*/}
                            {/*                : 0);*/}

                            {/*        lycancelledRatio =*/}
                            {/*            lycancelledRatio +*/}
                            {/*            (lyMonthData?.[0]?.["CancelledRatio"]*/}
                            {/*                ? parseFloat(lyMonthData?.[0]?.["CancelledRatio"])*/}
                            {/*                : 0);*/}

                            {/*        lytotalLoss =*/}
                            {/*            lytotalLoss +*/}
                            {/*            (lyMonthData?.[0]?.["TotalLoss"]*/}
                            {/*                ? parseInt(lyMonthData?.[0]?.["TotalLoss"])*/}
                            {/*                : 0);*/}

                            {/*        if (*/}
                            {/*            lyMonthData?.[0]?.["ADR"] !== "0" &&*/}
                            {/*            lyMonthData?.[0]?.["ADR"]*/}
                            {/*        ) {*/}
                            {/*            lyadrCount = lyadrCount + 1;*/}
                            {/*        }*/}

                            {/*        if (*/}
                            {/*            lyMonthData?.[0]?.["CancelledRatio"] !== "0.00" &&*/}
                            {/*            lyMonthData?.[0]?.["CancelledRatio"]*/}
                            {/*        ) {*/}
                            {/*            lycancelledRatioCount = lycancelledRatioCount + 1;*/}
                            {/*        }*/}

                            {/*        stlyinventory =*/}
                            {/*            stlyinventory +*/}
                            {/*            (stlyMonthData?.[0]?.["TotalInventory"]*/}
                            {/*                ? parseInt(stlyMonthData?.[0]?.["TotalInventory"])*/}
                            {/*                : 0);*/}

                            {/*        stlycancelledNights =*/}
                            {/*            stlycancelledNights +*/}
                            {/*            (stlyMonthData?.[0]?.["CancelledNights"]*/}
                            {/*                ? parseInt(stlyMonthData?.[0]?.["CancelledNights"])*/}
                            {/*                : 0);*/}

                            {/*        stlyadr =*/}
                            {/*            stlyadr +*/}
                            {/*            (stlyMonthData?.[0]?.["ADR"]*/}
                            {/*                ? parseInt(stlyMonthData?.[0]?.["ADR"])*/}
                            {/*                : 0);*/}

                            {/*        stlycancelledRatio =*/}
                            {/*            stlycancelledRatio +*/}
                            {/*            (stlyMonthData?.[0]?.["CancelledRatio"]*/}
                            {/*                ? parseFloat(stlyMonthData?.[0]?.["CancelledRatio"])*/}
                            {/*                : 0);*/}

                            {/*        stlytotalLoss =*/}
                            {/*            stlytotalLoss +*/}
                            {/*            (stlyMonthData?.[0]?.["TotalLoss"]*/}
                            {/*                ? parseInt(stlyMonthData?.[0]?.["TotalLoss"])*/}
                            {/*                : 0);*/}

                            {/*        if (*/}
                            {/*            stlyMonthData?.[0]?.["ADR"] !== "0" &&*/}
                            {/*            stlyMonthData?.[0]?.["ADR"]*/}
                            {/*        ) {*/}
                            {/*            stlyadrCount = stlyadrCount + 1;*/}
                            {/*        }*/}

                            {/*        if (*/}
                            {/*            stlyMonthData?.[0]?.["CancelledRatio"] !== "0.00" &&*/}
                            {/*            stlyMonthData?.[0]?.["CancelledRatio"]*/}
                            {/*        ) {*/}
                            {/*            stlycancelledRatiocount = stlycancelledRatiocount + 1;*/}
                            {/*        }*/}

                            {/*        return (*/}
                            {/*            <React.Fragment key={index}>*/}
                            {/*                <tr className="shadowOnHover">*/}
                            {/*                    <td className="text-center border_right">{item}</td>*/}
                            {/*                    <td className="text-center">*/}
                            {/*                        {cyMonthData?.[0]?.["Total Inventory"]*/}
                            {/*                            ? commonService.formateRoom(*/}
                            {/*                                cyMonthData?.[0]?.["Total Inventory"]*/}
                            {/*                            )*/}
                            {/*                            : 0}*/}
                            {/*                    </td>*/}
                            {/*                    <td className="text-center">*/}
                            {/*                        {cyMonthData?.[0]?.["CancelledNights"]*/}
                            {/*                            ? commonService.formateRoom(*/}
                            {/*                                cyMonthData?.[0]?.["CancelledNights"]*/}
                            {/*                            )*/}
                            {/*                            : 0}*/}
                            {/*                    </td>*/}
                            {/*                    <td className="text-end">*/}
                            {/*                        {cyMonthData?.[0]?.["ADR"]*/}
                            {/*                            ? commonService.formateAmount(*/}
                            {/*                                cyMonthData?.[0]?.["ADR"]*/}
                            {/*                            )*/}
                            {/*                            : commonService.formateAmount(0)}*/}
                            {/*                    </td>*/}
                            {/*                    <td className="text-center">*/}
                            {/*                        {cyMonthData?.[0]?.["CancelledRatio"]*/}
                            {/*                            ? Math.round(cyMonthData?.[0]?.["CancelledRatio"])*/}
                            {/*                            : 0}*/}
                            {/*                        %*/}
                            {/*                    </td>*/}
                            {/*                    <td className="text-end border_right">*/}
                            {/*                        {cyMonthData?.[0]?.["TotalLoss"]*/}
                            {/*                            ? commonService.formateAmount(*/}
                            {/*                                cyMonthData?.[0]?.["TotalLoss"]*/}
                            {/*                            )*/}
                            {/*                            : commonService.formateAmount(0)}*/}
                            {/*                    </td>*/}
                            {/*                    <td className="text-center">*/}
                            {/*                        {stlyMonthData?.[0]?.["TotalInventory"]*/}
                            {/*                            ? commonService.formateRoom(*/}
                            {/*                                stlyMonthData?.[0]?.["TotalInventory"]*/}
                            {/*                            )*/}
                            {/*                            : 0}*/}
                            {/*                    </td>*/}
                            {/*                    <td className="text-center">*/}
                            {/*                        {stlyMonthData?.[0]?.["CancelledNights"]*/}
                            {/*                            ? commonService.formateRoom(*/}
                            {/*                                stlyMonthData?.[0]?.["CancelledNights"]*/}
                            {/*                            )*/}
                            {/*                            : 0}*/}
                            {/*                    </td>*/}
                            {/*                    <td className="text-end">*/}
                            {/*                        {stlyMonthData?.[0]?.["ADR"]*/}
                            {/*                            ? commonService.formateAmount(*/}
                            {/*                                stlyMonthData?.[0]?.["ADR"]*/}
                            {/*                            )*/}
                            {/*                            : commonService.formateAmount(0)}*/}
                            {/*                    </td>*/}
                            {/*                    <td className="text-center">*/}
                            {/*                        {stlyMonthData?.[0]?.["CancelledRatio"]*/}
                            {/*                            ? Math.round(stlyMonthData?.[0]?.["CancelledRatio"])*/}
                            {/*                            : 0}*/}
                            {/*                        %*/}
                            {/*                    </td>*/}
                            {/*                    <td className="text-end border_right">*/}
                            {/*                        {stlyMonthData?.[0]?.["TotalLoss"]*/}
                            {/*                            ? commonService.formateAmount(*/}
                            {/*                                stlyMonthData?.[0]?.["TotalLoss"]*/}
                            {/*                            )*/}
                            {/*                            : commonService.formateAmount(0)}*/}
                            {/*                    </td>*/}
                            {/*                    <td className="text-center">*/}
                            {/*                        {lyMonthData?.[0]?.["TotalInventory"]*/}
                            {/*                            ? commonService.formateRoom(*/}
                            {/*                                lyMonthData?.[0]?.["TotalInventory"]*/}
                            {/*                            )*/}
                            {/*                            : 0}*/}
                            {/*                    </td>*/}
                            {/*                    <td className="text-center">*/}
                            {/*                        {lyMonthData?.[0]?.["CancelledNights"]*/}
                            {/*                            ? commonService.formateRoom(*/}
                            {/*                                lyMonthData?.[0]?.["CancelledNights"]*/}
                            {/*                            )*/}
                            {/*                            : 0}*/}
                            {/*                    </td>*/}
                            {/*                    <td className="text-end">*/}
                            {/*                        {lyMonthData?.[0]?.["ADR"]*/}
                            {/*                            ? commonService.formateAmount(*/}
                            {/*                                lyMonthData?.[0]?.["ADR"]*/}
                            {/*                            )*/}
                            {/*                            : commonService.formateAmount(0)}*/}
                            {/*                    </td>*/}
                            {/*                    <td className="text-center">*/}
                            {/*                        {lyMonthData?.[0]?.["CancelledRatio"]*/}
                            {/*                            ? Math.round(lyMonthData?.[0]?.["CancelledRatio"])*/}
                            {/*                            : 0}*/}
                            {/*                        %*/}
                            {/*                    </td>*/}
                            {/*                    <td className="text-end">*/}
                            {/*                        {lyMonthData?.[0]?.["TotalLoss"]*/}
                            {/*                            ? commonService.formateAmount(*/}
                            {/*                                lyMonthData?.[0]?.["TotalLoss"]*/}
                            {/*                            )*/}
                            {/*                            : commonService.formateAmount(0)}*/}
                            {/*                    </td>*/}
                            {/*                </tr>*/}
                            {/*                {index === 11 && (*/}
                            {/*                    <tr className="shadowOnHover">*/}
                            {/*                        <td className="boldTd text-center border_right">*/}
                            {/*                            Total*/}
                            {/*                        </td>*/}
                            {/*                        <td className="boldTd text-center">*/}
                            {/*                            {commonService.formateRoom(inventory)}*/}
                            {/*                        </td>*/}
                            {/*                        <td className="boldTd text-center">*/}
                            {/*                            {commonService.formateRoom(cancelledNights)}*/}
                            {/*                        </td>*/}
                            {/*                        <td className="boldTd text-end">*/}
                            {/*                            {adr > 0*/}
                            {/*                                ? commonService.formateAmount(*/}
                            {/*                                    Math.round(adr / adrCount)*/}
                            {/*                                )*/}
                            {/*                                : commonService.formateAmount(0)}*/}
                            {/*                        </td>*/}
                            {/*                        <td className="boldTd text-center">*/}
                            {/*                            {cancelledRatio > 0*/}
                            {/*                                ? (cancelledRatio / cancelledRatioCount)?.toFixed(*/}
                            {/*                                    2*/}
                            {/*                                )*/}
                            {/*                                : 0}*/}
                            {/*                            %*/}
                            {/*                        </td>*/}
                            {/*                        <td className="boldTd text-end border_right">*/}
                            {/*                            {commonService.formateAmount(totalLoss)}*/}
                            {/*                        </td>*/}

                            {/*                        <td className="boldTd text-center">*/}
                            {/*                            {commonService.formateRoom(stlyinventory)}*/}
                            {/*                        </td>*/}
                            {/*                        <td className="boldTd text-center">*/}
                            {/*                            {commonService.formateRoom(stlycancelledNights)}*/}
                            {/*                        </td>*/}
                            {/*                        <td className="boldTd text-end">*/}
                            {/*                            {stlyadr > 0*/}
                            {/*                                ? commonService.formateAmount(*/}
                            {/*                                    Math.round(stlyadr / stlyadrCount)*/}
                            {/*                                )*/}
                            {/*                                : commonService.formateAmount(0)}*/}
                            {/*                        </td>*/}
                            {/*                        <td className="boldTd text-center">*/}
                            {/*                            {stlycancelledRatio > 0*/}
                            {/*                                ? (*/}
                            {/*                                    stlycancelledRatio / stlycancelledRatiocount*/}
                            {/*                                )?.toFixed(2)*/}
                            {/*                                : 0}*/}
                            {/*                            %*/}
                            {/*                        </td>*/}
                            {/*                        <td className="boldTd text-end border_right">*/}
                            {/*                            {commonService.formateAmount(stlytotalLoss)}*/}
                            {/*                        </td>*/}

                            {/*                        <td className="boldTd text-center">*/}
                            {/*                            {commonService.formateRoom(lyinventory)}*/}
                            {/*                        </td>*/}
                            {/*                        <td className="boldTd text-center">*/}
                            {/*                            {commonService.formateRoom(lycancelledNights)}*/}
                            {/*                        </td>*/}
                            {/*                        <td className="boldTd text-end">*/}
                            {/*                            {lyadr > 0*/}
                            {/*                                ? commonService.formateAmount(*/}
                            {/*                                    Math.round(lyadr / lyadrCount)*/}
                            {/*                                )*/}
                            {/*                                : commonService.formateAmount(0)}*/}
                            {/*                        </td>*/}
                            {/*                        <td className="boldTd text-center">*/}
                            {/*                            {lycancelledRatio > 0*/}
                            {/*                                ? (*/}
                            {/*                                    lycancelledRatio / lycancelledRatioCount*/}
                            {/*                                )?.toFixed(2)*/}
                            {/*                                : 0}*/}
                            {/*                            %*/}
                            {/*                        </td>*/}
                            {/*                        <td className="boldTd text-end">*/}
                            {/*                            {commonService.formateAmount(lytotalLoss)}*/}
                            {/*                        </td>*/}
                            {/*                    </tr>*/}
                            {/*                )}*/}
                            {/*            </React.Fragment>*/}
                            {/*        );*/}
                            {/*    })*/}
                            {/*)}*/}
                        </tbody>
                    </table>
                </div>
            </div>
            {api !== 0 && (
                <Comments widgetDetails={para} editorId={"AnnualCancellationSummary"} />
            )}

            {/* {showNoteSidebar && (
        <WidgetNote
          show={showNoteSidebar}
          handleClose={closeNoteSideBar}
          widgetId={para?.widgetId}
          propertyId={propertyDetailFromRTK?.propertyid}
          rowTitle={para?.rowTitle}
        />
      )} */}
            {showNoteSidebar && (
                <AddWidgetModal
                    showModal={showNoteSidebar}
                    closeModal={closeNoteSideBar}
                    widgetId={para?.widgetId}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={para?.rowTitle}
                />
            )}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
        </div>
    );
};

export default AnnualCancellationSummary;
